export default "__VITE_ASSET__b8bc7e21__"